import { render, staticRenderFns } from "./EntityActivityUserInfo.vue?vue&type=template&id=166bd42b&scoped=true"
import script from "./EntityActivityUserInfo.vue?vue&type=script&lang=js"
export * from "./EntityActivityUserInfo.vue?vue&type=script&lang=js"
import style0 from "./EntityActivityUserInfo.vue?vue&type=style&index=0&id=166bd42b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166bd42b",
  null
  
)

export default component.exports